import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => createStyles({
    title: {
        fontWeight: 600,
    },
}));

export default useStyles;
